import { useState, useEffect } from "react";
import { useAvailableFilterValues } from "../../../features/filterValues/lib/api/hooks/useAvailableFilterValues.js";
import { excludeInvalidFilterGrid } from "./excludeInvalidFilterGrid.js";
const useAdjustedFilterPanelLayout = (layout) => {
  const { data: filterValuesItem, isSuccess } = useAvailableFilterValues();
  const filterRootGrid = layout;
  const [adjustedFilterPanelLayout, setAdjustedFilterPanelLayout] = useState(() => {
    if (!filterValuesItem) {
      return null;
    }
    const { data } = filterValuesItem;
    const adjustedGrid = excludeInvalidFilterGrid(filterRootGrid, data);
    return adjustedGrid;
  });
  useEffect(() => {
    if (!isSuccess || adjustedFilterPanelLayout) {
      return;
    }
    const { data } = filterValuesItem;
    const adjustedGrid = excludeInvalidFilterGrid(filterRootGrid, data);
    setAdjustedFilterPanelLayout(adjustedGrid);
  }, [isSuccess, filterValuesItem, layout, adjustedFilterPanelLayout, filterRootGrid]);
  return adjustedFilterPanelLayout || filterRootGrid;
};
export {
  useAdjustedFilterPanelLayout
};
